import { InputOption } from "../../classes/index";
import { ExtendedActionType } from "./index";

export function addImagesToLoad(dateStrings: Array<string>) {
    return {
        type: ExtendedActionType.AddNewImagesToLoad,
        value: dateStrings
    }
}

export function updateClientRect(month: string, element: HTMLElement) {
    return {
        type: ExtendedActionType.UpdateMonthElements,
        value: { month, element }
    }
}

export function waitForImage(monthString: string, id: string) {
    return {
        type: ExtendedActionType.WaitForImage,
        value: { monthString, id }
    }
}

export function imageHasLoaded(monthString: string, id: string) {
    return {
        type: ExtendedActionType.ImageHasLoaded,
        value: { monthString, id }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/redux/actions/lazy-loader-actions.ts